export const titles = [
  { number: "1", name: "Πόσο Καλά Γνωρίζετε τον Θεό;" },
  { number: "2", name: "Θα Επιζήσετε Εσείς από τις Τελευταίες Ημέρες;" },
  {
    number: "3",
    name: "Να Προχωρείτε Μαζί με την Ενοποιημένη Οργάνωση του Ιεχωβά",
  },
  { number: "4", name: "Αποδείξεις Περί Θεού στον Κόσμο που μας Περιβάλλει" },
  { number: "5", name: "Πραγματική Βοήθεια για την Οικογένεια" },
  {
    number: "6",
    name: "Ο Κατακλυσμός των Ημερών του Νώε και η Σημασία του για Εμάς",
  },
  { number: "7", name: "Να Μιμείστε “τον Πατέρα του Τρυφερού Ελέους”" },
  {
    number: "8",
    name: "Ας Ζούμε για να Κάνουμε το Θέλημα του Θεού και Όχι το Δικό Μας",
  },
  { number: "9", name: "Να Ακούτε τον Λόγο του Θεού και να τον Εκτελείτε" },
  { number: "10", name: "Να Είστε Έντιμοι σε Όλα Όσα Λέτε και Κάνετε" },
  { number: "11", name: "Μην Είστε «Μέρος του Κόσμου», Μιμούμενοι τον Χριστό" },
  {
    number: "12",
    name: "Η Άποψή σας για την Εξουσία Έχει Σημασία για τον Θεό",
  },
  { number: "13", name: "Η Θεϊκή Άποψη για το Σεξ και τον Γάμο" },
  { number: "14", name: "Ένας Καθαρός Λαός Τιμάει τον Ιεχωβά" },
  { number: "15", name: "«Ας Κάνουμε το Καλό σε Όλους»" },
  { number: "16", name: "Να Ενισχύετε Συνεχώς τη Σχέση σας με τον Θεό" },
  { number: "17", name: "Πώς να Δοξάζουμε τον Θεό με Όλα Όσα Έχουμε" },
  { number: "18", name: "Να Κάνετε τον Ιεχωβά Οχυρό Σας" },
  { number: "19", name: "Το Μέλλον Σας—Πώς Μπορείτε να το Μάθετε?" },
  {
    number: "20",
    name: "Μήπως Έφτασε ο Καιρός να Κυβερνήσει ο Θεός τον Κόσμο?",
  },
  {
    number: "21",
    name: "Να Θεωρείτε Πολύτιμη τη Θέση σας στη Διευθέτηση της Βασιλείας",
  },
  { number: "22", name: "Ωφελείστε Εσείς από τις Προμήθειες του Ιεχωβά?" },
  { number: "23", name: "Η Ζωή Έχει Πράγματι Σκοπό" },
  {
    number: "24",
    name: "Ένα «Μαργαριτάρι Μεγάλης Αξίας»—Εσείς το Έχετε Βρει?",
  },
  { number: "25", name: "Να Αντιστέκεστε στο Πνεύμα του Κόσμου!" },
  { number: "26", name: "(Δεν είναι διαθέσιμη)" },
  { number: "27", name: "Κάντε μια Καλή Αρχή στον Γάμο Σας" },
  { number: "28", name: "Να Δείχνετε Σεβασμό και Αγάπη Μέσα στον Γάμο Σας" },
  { number: "29", name: "Ανατροφή Παιδιών—Ευθύνες και Ανταμοιβές" },
  { number: "30", name: "Βελτιώστε την Επικοινωνία στην Οικογένειά Σας" },
  { number: "31", name: "Έχετε Συναίσθηση της Πνευματικής σας Ανάγκης;" },
  { number: "32", name: "Αντιμετωπίστε με Επιτυχία τις Ανησυχίες της Ζωής" },
  { number: "33", name: "Θα Υπάρξει Ποτέ Αληθινή Δικαιοσύνη;" },
  { number: "34", name: "(Δεν είναι διαθέσιμη)" },
  { number: "35", name: "Μπορείτε να Ζείτε για Πάντα; Εσείς θα Ζήσετε;" },
  { number: "36", name: "Αυτό Είναι Όλο και Όλο η Ζωή του Ανθρώπου;" },
  { number: "37", name: "Είναι οι Οδοί του Θεού Πραγματικά Ωφέλιμες;" },
  { number: "38", name: "Πώς Μπορείτε να Επιζήσετε από το Τέλος του Κόσμου;" },
  { number: "39", name: "Να Είστε Πεπεισμένοι για τη Θεϊκή Νίκη!" },
  { number: "40", name: "(Δεν είναι διαθέσιμη)" },
  { number: "41", name: "«Σταθείτε και Δείτε τη Σωτηρία του Ιεχωβά»" },
  { number: "42", name: "Πώς σας Επηρεάζει η Βασιλεία του Θεού" },
  { number: "43", name: "Οι Απαιτήσεις του Θεού—Πάντοτε Ωφέλιμες" },
  {
    number: "44",
    name: "Πώς Μπορούν να σας Ωφελήσουν οι Διδασκαλίες του Ιησού;",
  },
  { number: "45", name: "Ακολουθήστε την Οδό που Οδηγεί στη Ζωή" },
  { number: "46", name: "Διατηρήστε Σταθερή την Πεποίθησή σας Μέχρι το Τέλος" },
  { number: "47", name: "(Δεν είναι διαθέσιμη)" },
  {
    number: "48",
    name: "Επιτυχής Αντιμετώπιση της Δοκιμασίας της Χριστιανικής Οσιότητας",
  },
  { number: "49", name: "Μια Καθαρή Γη—Είναι Εφικτή;" },
  { number: "50", name: "Πώς να Παίρνετε Αποφάσεις που Οδηγούν σε Επιτυχία" },
  { number: "51", name: "Μεταμορφώνει η Αλήθεια τη Ζωή Σας;" },
  { number: "52", name: "Ποιος Είναι ο Δικός σας Θεός;" },
  {
    number: "53",
    name: "Συμφωνεί ο Δικός σας Τρόπος Σκέψης με τον Τρόπο Σκέψης του Θεού;",
  },
  { number: "54", name: "Οικοδομήστε Πίστη στον Θεό και στις Υποσχέσεις Του" },
  { number: "55", name: "Πώς Μπορείτε να Κάνετε Καλό Όνομα Ενώπιον του Θεού;" },
  { number: "56", name: "Ποιον Ηγέτη Μπορείτε να Εμπιστευτείτε;" },
  { number: "57", name: "Πώς να Αντέξετε το Διωγμό" },
  { number: "58", name: "Ποιοι Είναι οι Πραγματικοί Ακόλουθοι του Χριστού;" },
  { number: "59", name: "Θα Θερίσετε ό,τι Σπέρνετε" },
  { number: "60", name: "Πόσο Νόημα Έχει η Ζωή Σας;" },
  { number: "61", name: "Σε Τίνος τις Υποσχέσεις Βασίζεστε;" },
  { number: "62", name: "Η Μόνη Θεραπεία για το Άρρωστο Ανθρώπινο Γένος" },
  { number: "63", name: "Έχετε το Ευαγγελιστικό Πνεύμα;" },
  { number: "64", name: "Εσείς τι Αγαπάτε; Τις Απολαύσεις ή τον Θεό;" },
  { number: "65", name: "Πώς να Καλλιεργείτε Ειρήνη σε έναν Θυμωμένο Κόσμο" },
  { number: "66", name: "Θα Είστε Εσείς Εργάτης στον Θερισμό;" },
  { number: "67", name: "Να Στοχάζεστε τον Λόγο και τα Έργα του Ιεχωβά" },
  { number: "68", name: "Κρατάτε Μέσα σας Μνησικακία ή Είστε Συγχωρητικοί;" },
  { number: "69", name: "Γιατί Πρέπει να Δείχνουμε Αυτοθυσιαστική Αγάπη;" },
  { number: "70", name: "Θέστε στον Ιεχωβά την Εμπιστοσύνη Σας" },
  { number: "71", name: "Να “Μένετε Άγρυπνοι”—Γιατί και Πώς;" },
  {
    number: "72",
    name: "Η Αγάπη Χαρακτηρίζει την Αληθινή Χριστιανική Εκκλησία",
  },
  { number: "73", name: "Αποκτήστε Σοφή Καρδιά" },
  { number: "74", name: "Τα Μάτια του Ιεχωβά Είναι Πάνω Μας" },
  {
    number: "75",
    name: "Αναγνωρίζετε Εσείς την Κυριαρχία του Ιεχωβά στην Προσωπική σας Ζωή;",
  },
  {
    number: "76",
    name: "Βιβλικές Αρχές—Μπορούν να μας Βοηθήσουν να Αντεπεξερχόμαστε στα Σημερινά Προβλήματα;",
  },
  { number: "77", name: "Να Ακολουθείτε την Πορεία της Φιλοξενίας" },
  { number: "78", name: "Να Υπηρετείτε τον Ιεχωβά με Χαρούμενη Καρδιά" },
  {
    number: "79",
    name: "Φιλία με τον Θεό, Φιλία με τον Κόσμο—Ποιο θα Διαλέξετε;",
  },
  {
    number: "80",
    name: "Στηρίζετε τις Ελπίδες σας στην Επιστήμη ή στην Αγία Γραφή;",
  },
  {
    number: "81",
    name: "Ποιοι Έχουν τα Κατάλληλα Προσόντα να Είναι Διάκονοι του Θεού;",
  },
  { number: "82", name: "Ο Ιεχωβά και ο Χριστός—Είναι Μέρος μιας Τριάδας;" },
  { number: "83", name: "Ο Καιρός Κρίσης της Θρησκείας" },
  {
    number: "84",
    name: "Θα Διαφύγετε από το Τέλος που Προορίζεται να Έχει Αυτός ο Κόσμος;",
  },
  { number: "85", name: "Καλά Νέα Μέσα σε ένα Βίαιο Κόσμο" },
  { number: "86", name: "Προσευχές που Εισακούονται από τον Θεό" },
  { number: "87", name: "Ποια Είναι η Σχέση σας με τον Θεό;" },
  {
    number: "88",
    name: "Γιατί Πρέπει να Ζούμε Σύμφωνα με τους Κανόνες της Αγίας Γραφής;",
  },
  { number: "89", name: "Ελάτε, Εσείς που Διψάτε για την Αλήθεια!" },
  { number: "90", name: "Επιδιώξτε την Πραγματική Ζωή!" },
  { number: "91", name: "Η Παρουσία του Μεσσία και η Διακυβέρνησή Του" },
  { number: "92", name: "Ο Ρόλος της Θρησκείας στις Παγκόσμιες Υποθέσεις" },
  { number: "93", name: "«Θεομηνίες»—Πώς τις Θεωρείτε;" },
  {
    number: "94",
    name: "Η Αληθινή Θρησκεία Ανταποκρίνεται στις Ανάγκες της Ανθρώπινης Κοινωνίας",
  },
  {
    number: "95",
    name: "Η Άποψη της Αγίας Γραφής για τις Πνευματιστικές Πράξεις",
  },
  { number: "96", name: "Ποιο Είναι το Μέλλον της Θρησκείας;" },
  {
    number: "97",
    name: "Να Παραμένετε Άμεμπτοι Ανάμεσα σε μια Εξαχρειωμένη Γενιά",
  },
  { number: "98", name: "«Το Σκηνικό Αυτού του Κόσμου Αλλάζει»" },
  { number: "99", name: "Γιατί Μπορείτε να Εμπιστευτείτε την Αγία Γραφή" },
  { number: "100", name: "Αληθινή Φιλία με τον Θεό και τον Πλησίον" },
  { number: "101", name: "Ο Ιεχωβά—Ο Μεγαλειώδης Δημιουργός" },
  { number: "102", name: "Να Δίνετε Προσοχή στον Προφητικό Λόγο" },
  { number: "103", name: "Μπορείτε να Βρείτε Χαρά Υπηρετώντας τον Θεό" },
  { number: "104", name: "Γονείς—Οικοδομείτε με Πυρίμαχα Υλικά;" },
  { number: "105", name: "Πώς να Βρίσκουμε Παρηγοριά σε Όλες τις Θλίψεις Μας" },
  { number: "106", name: "Η Καταστροφή της Γης Επιφέρει τη Θεϊκή Ανταπόδοση" },
  {
    number: "107",
    name: "Ωφελείστε Εσείς από μια Εκπαιδευμένη Συνείδηση;",
  },
  { number: "108", name: "Πώς να Υπερνικήσετε το Φόβο για το Μέλλον" },
  { number: "109", name: "Η Βασιλεία του Θεού Είναι Κοντά" },
  {
    number: "110",
    name: "Στην Πετυχημένη Οικογενειακή Ζωή ο Θεός Βρίσκεται στην Πρώτη Θέση",
  },
  { number: "111", name: "Τι Επιτελεί η Θεραπεία των Εθνών;" },
  { number: "112", name: "Πώς να Εκδηλώνετε Αγάπη Μέσα σε έναν Άνομο Κόσμο" },
  {
    number: "113",
    name: "Πώς Μπορούν οι Νεαροί να Είναι Επιτυχημένοι και Ευτυχισμένοι;",
  },
  { number: "114", name: "Να Εκτιμάτε τα Θαύματα της Δημιουργίας του Θεού" },
  { number: "115", name: "Πώς να Προστατευτούμε από τις Παγίδες του Σατανά" },
  { number: "116", name: "Να Διαλέγετε τις Συναναστροφές σας Σοφά!" },
  { number: "117", name: "Πώς να Νικάτε το Κακό με το Καλό" },
  { number: "118", name: "Ας Βλέπουμε τους Νέους από την Άποψη του Ιεχωβά" },
  {
    number: "119",
    name: "Ο Αποχωρισμός των Χριστιανών από τον Κόσμο—Γιατί Είναι Ωφέλιμος",
  },
  {
    number: "120",
    name: "Γιατί να Υποταχθούμε στη Διακυβέρνηση του Θεού Τώρα",
  },
  { number: "121", name: "Μια Παγκόσμια Αδελφότητα Σώζεται από τη Συμφορά" },
  { number: "122", name: "Παγγήινη Ειρήνη—Από ποια Πηγή;" },
  { number: "123", name: "Γιατί Πρέπει να Είναι Διαφορετικοί οι Χριστιανοί" },
  { number: "124", name: "Βάση για Πίστη στη Θεοπνευστία της Αγίας Γραφής" },
  { number: "125", name: "Γιατί η Ανθρωπότητα Χρειάζεται Λύτρο" },
  { number: "126", name: "Ποιοι Μπορούν να Σωθούν;" },
  { number: "127", name: "Τι Συμβαίνει Όταν Πεθαίνουμε;" },
  { number: "128", name: "Άδης ή «Κόλαση»—Τόπος Πύρινων Βασάνων;" },
  { number: "129", name: "Είναι η Τριάδα Βιβλική Διδασκαλία;" },
  { number: "130", name: "Η Γη θα Παραμείνει για Πάντα" },
  { number: "131", name: "Υπάρχει Πράγματι Διάβολος;" },
  { number: "132", name: "Η Ανάσταση—Νίκη Κατά του Θανάτου!" },
  {
    number: "133",
    name: "Η Προέλευση των Ανθρώπων—Έχει Σημασία Τι Πιστεύετε;",
  },
  { number: "134", name: "Πρέπει να Τηρούν οι Χριστιανοί το Σάββατο;" },
  { number: "135", name: "Η Ιερότητα της Ζωής και του Αίματος" },
  { number: "136", name: "Επιδοκιμάζει ο Θεός τη Χρήση Εικόνων στη Λατρεία;" },
  { number: "137", name: "Συνέβησαν Πράγματι τα Βιβλικά Θαύματα;" },
  {
    number: "138",
    name: "Να Ζείτε με Σωφροσύνη Μέσα σε έναν Εξαχρειωμένο Κόσμο",
  },
  { number: "139", name: "Θεϊκή Σοφία Μέσα σε έναν Επιστημονικό Κόσμο" },
  { number: "140", name: "Ποιος Είναι στην Πραγματικότητα ο Ιησούς Χριστός;" },
  {
    number: "141",
    name: "Ο Στεναγμός της Ανθρώπινης Δημιουργίας—Πότε θα Τελειώσει;",
  },
  { number: "142", name: "Γιατί Πρέπει να Βρείτε Καταφύγιο στον Ιεχωβά" },
  { number: "143", name: "Να Εμπιστεύεστε στον Θεό" },
  { number: "144", name: "Μια Όσια Εκκλησία Υπό την Ηγεσία του Χριστού" },
  { number: "145", name: "Ποιος Είναι σαν τον Ιεχωβά τον Θεό Μας" },
  {
    number: "146",
    name: "Να Χρησιμοποιείτε την Εκπαίδευση για να Αινείτε τον Ιεχωβά",
  },
  { number: "147", name: "Να Εμπιστεύεστε στη Σωτήρια Δύναμη του Ιεχωβά" },
  { number: "148", name: "Συμμερίζεστε την Άποψη του Θεού για τη Ζωή;" },
  { number: "149", name: "Περπατάτε Εσείς με τον Θεό;" },
  {
    number: "150",
    name: "Είναι Αυτός ο Κόσμος Καταδικασμένος να Καταστραφεί;",
  },
  { number: "151", name: "Ο Ιεχωβά Είναι «Ασφαλές Ύψωμα» για το Λαό Του" },
  { number: "152", name: "Ο Αληθινός Αρμαγεδδών—Γιατί; Πότε;" },
  {
    number: "153",
    name: "Να Έχετε Διαρκώς στον Νου την “Ημέρα που Εμπνέει Δέος”!",
  },
  { number: "154", name: "Η Ανθρώπινη Διακυβέρνηση στη Ζυγαριά" },
  { number: "155", name: "Έχει Φτάσει η Ώρα της Κρίσης της Βαβυλώνας;" },
  { number: "156", name: "Η Ημέρα της Κρίσης—Καιρός για Φόβο ή για Ελπίδα;" },
  {
    number: "157",
    name: "Πώς Στολίζουν οι Αληθινοί Χριστιανοί τη Θεϊκή Διδασκαλία",
  },
  { number: "158", name: "Να Είστε Θαρραλέοι και να Εμπιστεύεστε στον Ιεχωβά" },
  { number: "159", name: "Βρείτε Ασφάλεια Μέσα σε έναν Επικίνδυνο Κόσμο" },
  { number: "160", name: "Διαφυλάξτε τη Χριστιανική σας Ταυτότητα!" },
  { number: "161", name: "Γιατί Υπέφερε και Πέθανε ο Ιησούς;" },
  { number: "162", name: "Απελευθέρωση από έναν Κόσμο Σκοταδιού" },
  { number: "163", name: "Γιατί Πρέπει να Φοβόμαστε τον Αληθινό Θεό;" },
  {
    number: "164",
    name: "Εξακολουθεί να Ασκεί ο Θεός τον Έλεγχο της Κατάστασης;",
  },
  { number: "165", name: "Τίνος τις Αξίες Θεωρείτε Εσείς Πολύτιμες;" },
  {
    number: "166",
    name: "Πώς να Αντιμετωπίζουμε το Μέλλον με Πίστη και Θάρρος",
  },
  { number: "167", name: "Να Ενεργείτε Σοφά σε έναν Ασύνετο Κόσμο" },
  {
    number: "168",
    name: "Μπορείτε να Νιώθετε Ασφαλείς σε Αυτόν τον Ταραγμένο Κόσμο!",
  },
  { number: "169", name: "Γιατί Πρέπει να Καθοδηγούμαστε από την Αγία Γραφή;" },
  {
    number: "170",
    name: "Ποιος Έχει τα Προσόντα να Κυβερνήσει την Ανθρωπότητα;",
  },
  {
    number: "171",
    name: "Μπορείτε να Απολαμβάνετε Ζωή με Ειρήνη Τώρα—Και για Πάντα!",
  },
  { number: "172", name: "Ποια Είναι η Υπόστασή σας Ενώπιον του Θεού;" },
  { number: "173", name: "Υπάρχει Αληθινή Θρησκεία από την Άποψη του Θεού;" },
  { number: "174", name: "Ο Νέος Κόσμος του Θεού—Ποιοι θα Ζήσουν σε Αυτόν;" },
  { number: "175", name: "Τι Πιστοποιεί την Αυθεντικότητα της Αγίας Γραφής;" },
  { number: "176", name: "Αληθινή Ειρήνη και Ασφάλεια—Πότε;" },
  {
    number: "177",
    name: "Πού Μπορείτε να Βρείτε Βοήθεια σε Καιρούς Στενοχώριας;",
  },
  { number: "178", name: "Να Περπατάτε στην Οδό της Ακεραιότητας" },
  {
    number: "179",
    name: "Να Απορρίπτετε τις Κοσμικές Φαντασιώσεις, να Επιδιώκετε τις Πραγματικότητες της Βασιλείας",
  },
  {
    number: "180",
    name: "Ανάσταση—Γιατί Αυτή η Ελπίδα Πρέπει να Είναι Πραγματική για Εσάς",
  },
  { number: "181", name: "Μήπως Είναι Πιο Αργά από ό,τι Νομίζετε;" },
  { number: "182", name: "Τι Κάνει για Εμάς η Βασιλεία του Θεού Τώρα" },
  {
    number: "183",
    name: "Να Απομακρύνετε τα Μάτια σας από ό,τι Δεν Έχει Αξία!",
  },
  { number: "184", name: "Τελειώνουν Όλα με το Θάνατο;" },
  { number: "185", name: "Επηρεάζει η Αλήθεια τη Ζωή Σας;" },
  { number: "186", name: "Ενωθείτε με τον Ευτυχισμένο Λαό του Θεού" },
  {
    number: "187",
    name: "Γιατί να Επιτρέπει ένας Στοργικός Θεός την Πονηρία;",
  },
  { number: "188", name: "Θέτετε την Πεποίθησή σας στον Ιεχωβά;" },
  {
    number: "189",
    name: "Περπατώντας με τον Θεό Ευλογούμαστε Τώρα και για Πάντα",
  },
  { number: "190", name: "Μια Υπόσχεση για Τέλεια Οικογενειακή Ευτυχία" },
  { number: "191", name: "Πώς Νικάει τον Κόσμο η Αγάπη και η Πίστη" },
  {
    number: "192",
    name: "Βαδίζετε Εσείς στον Δρόμο που Οδηγεί στην Αιώνια Ζωή;",
  },
  { number: "193", name: "Διάσωση Μέσα από την Παγκόσμια Στενοχώρια" },
  { number: "194", name: "Πώς μας Ωφελεί η Θεϊκή Σοφία" },
];
